import { render, staticRenderFns } from "./StatusCollapseSection.vue?vue&type=template&id=a2fc35de&scoped=true&"
import script from "./StatusCollapseSection.vue?vue&type=script&lang=js&"
export * from "./StatusCollapseSection.vue?vue&type=script&lang=js&"
import style0 from "./StatusCollapseSection.vue?vue&type=style&index=0&id=a2fc35de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fc35de",
  null
  
)

export default component.exports